import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { calculatorCategories, getCalculatorsByCategory } from '@/lib/calculator-data';
import { ArrowRight } from 'lucide-react';
import React from 'react';
import { useSEO } from '@/hooks/useSEO';

export default function Home() {
  const calculatorsByCat = getCalculatorsByCategory();

  useSEO(
    'Earning Calculators.Com - Financial Calculators for the Modern Workforce',
    'Empowering creators, freelancers, and gig workers to master their finances. A suite of 40+ free financial calculators designed for the modern workforce.'
  );

  return (
    <div className="container mx-auto px-4 py-8 md:py-16">
      <section className="text-center mb-16">
        <h1 className="font-headline text-4xl md:text-6xl font-bold tracking-tighter mb-4">
          Empowering creators, freelancers, and gig workers to master their finances.
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
          Earning Calculators.Com provides a suite of 40+ free financial calculators designed for creators, freelancers, and the modern workforce.
        </p>
      </section>

      <div className="space-y-12">
        {calculatorCategories.map((category, index) => (
          <section key={category.id}>
            <div className="flex items-center gap-4 mb-6">
              <category.icon className="w-8 h-8 text-primary" />
              <h2 className="font-headline text-3xl font-semibold tracking-tight">{category.name}</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {calculatorsByCat[category.id]?.map((tool) => (
                <Link to={`/calculators/${tool.slug}`} key={tool.slug} className="group">
                  <Card className="h-full hover:shadow-primary/20 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 flex flex-col">
                    <CardHeader>
                      <CardTitle className="flex justify-between items-start gap-4">
                        <span className="font-headline text-xl">{tool.name}</span>
                        <tool.icon className="w-6 h-6 text-muted-foreground group-hover:text-primary transition-colors" />
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex-grow flex flex-col justify-between">
                      <p className="text-muted-foreground mb-4">{tool.description}</p>
                      <div className="flex items-center text-sm font-medium text-primary group-hover:gap-2 transition-all">
                        <span>Use Tool</span>
                        <ArrowRight className="w-4 h-4" />
                      </div>
                    </CardContent>
                  </Card>
                </Link>
              ))}
            </div>
            {(index === 0 || index === 2) && (
              <div className="my-12 flex justify-center">
                <div
                  className="w-full max-w-[728px] h-[90px] bg-gray-200/50 rounded-lg flex items-center justify-center text-transparent text-sm"
                  data-ad-slot="homepage-leaderboard"
                  aria-label="Advertisement"
                >
                  Advertisement
                </div>
              </div>
            )}
          </section>
        ))}
      </div>
    </div>
  );
}